/**
 * Cookie consent + Google Consent Mode v2 helpers.
 *
 * Storage: localStorage key `aif_cookie_consent` = JSON {
 *   analytics: boolean,       // GA4, PostHog
 *   marketing: boolean,       // ads, retargeting (currently unused, reserved)
 *   timestamp: ISO string,
 *   version: 1,
 * }
 *
 * Re-ask after 12 months.
 */

const KEY = "aif_cookie_consent";
const REASK_MS = 365 * 24 * 60 * 60 * 1000;
export const CONSENT_VERSION = 1;

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.version !== CONSENT_VERSION) return null;
    if (parsed.timestamp && Date.now() - new Date(parsed.timestamp).getTime() > REASK_MS) return null;
    return parsed;
  } catch { return null; }
}

export function hasDecided() {
  return !!getConsent();
}

export function setConsent({ analytics, marketing }) {
  const payload = {
    analytics: !!analytics,
    marketing: !!marketing,
    timestamp: new Date().toISOString(),
    version: CONSENT_VERSION,
  };
  try { localStorage.setItem(KEY, JSON.stringify(payload)); } catch { /* ignore */ }
  applyConsentToGtag(payload);
  window.dispatchEvent(new CustomEvent("aif-consent-changed", { detail: payload }));
  return payload;
}

export function clearConsent() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export function applyConsentToGtag(consent) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: consent.analytics ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
  });
}

// On app boot: if consent already persisted, replay it into gtag so GA4 picks it up.
export function bootConsent() {
  const c = getConsent();
  if (c) applyConsentToGtag(c);
}
